const leftPanelInitial = {
    height: 0,
    expanded: true,
    // level
    level: 1,
    // lock
    lockedAll: false,
    // apply
    filterChanged: false,
    // historicalRelations
    historyChanged: false,
    history: false,
    dateFrom: new Date(2000, 0, 1),
    dateTo: new Date(),
    // relationDirections
    directionChanged: false,
    linkDirection: 0,
    // ownershipInterest
    shareChecked: false,
    shareChanged: false,
    shareValue: 50,
    // customRelations
    customRelationsEnabled: false,
    // relationTypes
    rt: [],
    rtUsed: [],
    relationTypesChanged: false,
    relTypesAllChecked: false,
    relTypesAllPartial: false,
    // warningTypes
    wt: [],
    wtUsed: [],
    warTypesAllChecked: false,
    warTypesAllPartial: false,
}

const initialState = {
    leftPanel: { ...leftPanelInitial },
}

export {
    leftPanelInitial, initialState as leftPanelInitialState
};
